import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Modal from "../../shared/Modal";
import { FilePreview } from "../../shared/FilePreview";
import { CompanyDocument } from "winslow-core";
import "./DocumentPreviewModal.css";

type DocumentPreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  document: CompanyDocument | null;
};

export const DocumentPreviewModal: React.FC<DocumentPreviewModalProps> = ({
  isOpen,
  onClose,
  document,
}) => {
  const location = useLocation();
  const [dimensions, setDimensions] = useState<{
    width: number;
    height: number;
  } | null>(null);

  // Close modal on navigation
  useEffect(() => {
    if (isOpen) {
      onClose();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!document || !document.cloudURL) {
      setDimensions(null);
      return;
    }

    const fileExtension = document.fileName?.split(".").pop()?.toLowerCase();

    // For images, we can get dimensions by loading the image
    if (
      fileExtension &&
      ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"].includes(
        fileExtension
      )
    ) {
      const img = new Image();
      img.onload = () => {
        setDimensions({ width: img.naturalWidth, height: img.naturalHeight });
      };
      img.onerror = () => {
        setDimensions(null);
      };
      img.src = document.cloudURL;
    } else {
      // For other file types, we can't easily get dimensions
      setDimensions(null);
    }
  }, [document]);

  if (!document || !document.cloudURL) {
    return null;
  }

  const fileExtension = document.fileName?.split(".").pop();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{
        maxWidth: "95vw",
        maxHeight: "95vh",
        width: "auto",
        height: "auto",
      }}
      canClose={true}
      allowClickout={true}>
      <div className="document-preview-modal">
        <div className="document-preview-header">
          <h3 className="document-preview-title">
            {document.name}
            {dimensions && (
              <span className="document-preview-dimensions">
                {" "}
                ({dimensions.width} × {dimensions.height}px)
              </span>
            )}
          </h3>
        </div>
        <div className="document-preview-content">
          <FilePreview
            url={document.cloudURL}
            title={document.name}
            fileExtension={fileExtension}
            className="document-preview-file"
          />
        </div>
      </div>
    </Modal>
  );
};
